import React from 'react';
import PropTypes from 'prop-types';

import { FormModal, CodeSquare01Icon } from '@metarouter-private/mr-mui';

import SampleEventForm from 'app/shared/components/sample-events/SampleEventForm';

import useOnSubmitSampleEvent from './useOnSubmitSampleEvent';

const MODAL_CONFIG = {
  title: 'New Sample Event',
  TitleIcon: CodeSquare01Icon,
  submitLabel: 'Create Sample Event',
  maxWidth: 'md',
  validationMode: 'all',
};

export default function CreateSampleEventModal({ open, onClose, eventJson, onSaveSuccess }) {
  const onSubmit = useOnSubmitSampleEvent({ onClose, onSaveSuccess });

  return (
    <FormModal {...MODAL_CONFIG} open={open} onClose={onClose} onSubmit={onSubmit}>
      <SampleEventForm defaultValues={{ eventJson }} />
    </FormModal>
  );
}

CreateSampleEventModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  eventJson: PropTypes.string,
  onSaveSuccess: PropTypes.func,
};
